/* HST — behaviour for the custom sections. No framework, no dependencies.
   1) Every [data-hst-buy] goes STRAIGHT TO CHECKOUT (no cart). Since G3 (2026-09-30) it is a
      <button> that POSTs #hst-buy-form (/cart/add, return_to /checkout), so it still works in one
      tap if this script never loads, and a crawler's GET can no longer create a checkout.
   2) Ön bakım: tap symptoms -> live count + message; the list rides into the order as a
      line-item property so the hoca sees it on the order.
   3) Sticky buy bar appears once the offer card has scrolled away.
   4) Language / country pill opens on HOVER on mouse devices (click still works). */
(function () {
  'use strict';
  var HT = function (k, d) { var o = window.HST_I18N; return (o && o[k]) || d; };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var OB_KEY = 'hst_onbakim';
  var buying = false;

  function obList() {
    if (window.HSTC) return window.HSTC.read();
    try { return JSON.parse(sessionStorage.getItem(OB_KEY) || 'null'); } catch (e) { return null; }
  }

  /* ---------- 1) buy -> checkout ---------- */
  function buy(el) {
    if (buying) return true;
    var vid = parseInt(el.getAttribute('data-variant'), 10);
    if (vid !== 54334973837676 || !window.fetch) return false;
    buying = true;
    var props = {};
    var ob = obList();
    if (ob && Array.isArray(ob.items) && ob.items.length) {
      props[HT('prop_ob', 'Ön Bakım')] = ob.items.length + '/' + ob.total + HT('prop_ob_sep', ' belirti: ') + ob.items.join('; ');
    }
    var src = el.getAttribute('data-hst-src');
    if (src) props[HT('prop_src', 'Geldiği bölüm')] = src;
    el.setAttribute('aria-busy', 'true');
    document.querySelectorAll('[data-hst-buy]').forEach(function (button) { button.setAttribute('aria-disabled', 'true'); });
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('clear');
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (data) {
        var line = data && data.items && data.items[0];
        if (!line || data.items.length !== 1 || Number(line.id) !== vid || Number(line.quantity) !== 1) throw new Error('quantity');
        window.location.href = root + 'checkout';
      })
      .catch(function () { window.location.href = el.href || (root + 'cart/' + vid + ':1'); });   /* permalink fallback (G3: buttons have no href; same permalink as before, built in JS so no crawler sees it) */
    return true;
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-hst-buy]');
    if (!el) return;
    if (buying) { e.preventDefault(); return; }
    if (e.button > 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    if (buy(el)) e.preventDefault();
  });
  window.addEventListener('pageshow', function () {
    buying = false;
    document.querySelectorAll('[data-hst-buy]').forEach(function (button) {
      button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled');
    });
  });

  /* ---------- 2) ön bakım ---------- */
  document.querySelectorAll('[data-hst-ob]').forEach(function (box) {
    var items = box.querySelectorAll('.hst-ob__item');
    var total = items.length;
    var countEl = box.querySelector('[data-ob-count]');
    var msgEl = box.querySelector('[data-ob-msg]');
    var waEl = box.querySelector('[data-ob-wa]');
    var waBase = waEl ? waEl.getAttribute('data-wa') : '';
    var msgs = JSON.parse(box.getAttribute('data-msgs') || '{}');
    var saved = obList();
    var labels = Array.prototype.map.call(items, function (b) { return b.textContent.trim(); });
    var carried = saved && Array.isArray(saved.items) ? saved.items.filter(function (label) { return labels.indexOf(label) < 0; }) : [];
    if (saved && Array.isArray(saved.items)) {
      items.forEach(function (b) { if (saved.items.indexOf(b.textContent.trim()) > -1) b.setAttribute('aria-pressed', 'true'); });
    }
    function update() {
      var sel = carried.slice();
      items.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') sel.push(b.textContent.trim()); });
      if (window.HSTC) sel = window.HSTC.save(sel).items;
      items.forEach(function (b) { b.setAttribute('aria-pressed', sel.indexOf(b.textContent.trim()) >= 0 ? 'true' : 'false'); });
      var n = sel.length;
      if (countEl) countEl.textContent = n + '/' + total;
      if (msgEl) msgEl.textContent = (n === 0 ? msgs.m0 : n < 3 ? msgs.m1 : n < 7 ? msgs.m2 : msgs.m3) || '';
      if (!window.HSTC) try { sessionStorage.setItem(OB_KEY, JSON.stringify({ items: sel, total: total })); } catch (e) {}
      if (waEl && waBase) {
        var t = n
          ? 'Esselamu Aleyküm Hocam, şu belirtiler bende var: ' + sel.join('; ') + '. Toplam ' + n + ' belirti.'
          : 'Esselamu Aleyküm Hocam, ön bakım için yazıyorum.';
        waEl.href = waBase + '?text=' + encodeURIComponent(t);
      }
    }
    items.forEach(function (b) {
      b.addEventListener('click', function () {
        b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        update();
      });
    });
    update();
  });

  /* ---------- 3) sticky buy bar ---------- */
  var bar = document.querySelector('[data-hst-sticky]');
  var card = document.querySelector('.hst-c-brand');
  var stickyHeader = document.querySelector('.htk header');
  if (bar && card) {
    var ob = document.querySelector('[data-hst-ob], [data-htk-ob]');
    var sync = function () {
      var heroRect = card.getBoundingClientRect();
      var headerBottom = stickyHeader ? stickyHeader.getBoundingClientRect().bottom : 0;
      var visibleTop = Math.max(0, Math.min(window.innerHeight, headerBottom));
      var obRect = ob && ob.getBoundingClientRect();
      var obVisible = obRect && obRect.top < window.innerHeight && obRect.bottom > visibleTop;
      var on = heroRect.bottom <= visibleTop && !obVisible;
      bar.classList.toggle('is-on', on);
      if (window.HSTC) window.HSTC.interactive(bar, on);
      else { bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bar.toggleAttribute('inert', !on); }
      document.body.classList.toggle('hst-sticky-on', on);
    };
    var pending = false;
    var schedule = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    };
    window.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule);
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(schedule);
      observer.observe(card); if (ob) observer.observe(ob);
    }
    sync();
  }

  /* ---------- 4) language / country pill on hover ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var wire = function () {
      document.querySelectorAll('dropdown-localization-component').forEach(function (c) {
        if (c.__hstHover) return;
        c.__hstHover = true;
        var t;
        c.addEventListener('mouseenter', function () {
          clearTimeout(t);
          if (typeof c.showPanel === 'function') c.showPanel();
          /* show every language at once (Türkçe / English) instead of a closed <select> */
          c.querySelectorAll('select.localization-form__select').forEach(function (s) {
            if (s.options.length > 1) { s.size = s.options.length; s.classList.add('hst-lang-open'); }
          });
        });
        c.addEventListener('mouseleave', function () {
          t = setTimeout(function () { if (typeof c.hidePanel === 'function') c.hidePanel(); }, 280);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
    window.addEventListener('load', wire);
  }

  /* Gallery, carousel and optional case comparison controls are owned by hst-c.js. */
})();


/* hst-cookie notice REMOVED (Chairman 2026-10-08): no cookie notice on TR and global markets.
   The EU banner is Shopify's own (snippet hst-consent), shown only in Shopify's consent regions. */
